import * as z from "zod";
import { Id } from "./ids.js";

/** Longest plain-English approval rule an owner can type. */
export const PLAIN_RULE_MAX_LENGTH = 200;

/** One structured rule a plain-English rule enforces. */
export const ApprovalPolicyRuleItemSchema = z.object({
  effect: z.enum(["always_allow", "require_approval", "deny"]),
  matchKind: z.enum(["tool", "connector", "category", "site"]),
  matchValue: z.string(),
});
export type ApprovalPolicyRuleItem = z.infer<typeof ApprovalPolicyRuleItemSchema>;

export const ApprovalPolicySchema = z.object({
  id: Id,
  botId: Id.nullable(),
  text: z.string(),
  rules: z.array(ApprovalPolicyRuleItemSchema),
  createdAt: z.string(),
});
export type ApprovalPolicy = z.infer<typeof ApprovalPolicySchema>;

export const ApprovalPolicyListSchema = z.object({
  policies: z.array(ApprovalPolicySchema),
  /** Whether the caller may add or remove rules in this list. */
  canEdit: z.boolean(),
  /** What always asks, whatever a rule says, as tool names. */
  alwaysAsk: z.array(z.string()),
});
export type ApprovalPolicyList = z.infer<typeof ApprovalPolicyListSchema>;

export const AskerAccessSchema = z.enum(["chat", "actions", "connections"]);
export type AskerAccessLevel = z.infer<typeof AskerAccessSchema>;

export const BotAskerSchema = z.object({
  userId: Id,
  name: z.string(),
  email: z.string(),
  status: z.enum(["pending", "approved", "declined"]),
  access: AskerAccessSchema,
  requestedAt: z.string(),
});
export type BotAsker = z.infer<typeof BotAskerSchema>;
